<template>
  <j-select
    v-if="$vuetify.breakpoint.xsOnly"
    multiple
    combo-box
    chips
    simple-item
    :solo-inverted="soloInverted"
    :filled="filled"
    :prepend-icon="icon ? 'fa-notes-medical' : ''"
    hide-details
    :items="getUniqueAllergens"
    :value="value"
    label="Allergènes"
    @change="v => $emit('input', v)"
  ></j-select>
  <v-combobox
    v-else
    multiple
    chips
    deletable-chips
    filled
    dense
    class="no-before"
    :prepend-icon="icon ? 'fa-notes-medical' : ''"
    hide-details
    :items="getUniqueAllergens"
    :value="value"
    label="Allergènes"
    autocomplete="off"
    :search-input.sync="searchInput"
    @change="onChange"
  ></v-combobox>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "RecipeProductAllergenInput",
  props: {
    value: {
      type: Array,
      required: true
    },
    icon: {
      type: Boolean,
      default: true
    },
    soloInverted: {
      type: Boolean,
      default: false
    },
    filled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getProducts"]),
    getUniqueAllergens() {
      return [
        ...new Set(
          this.getProducts
            .map(x => {
              if (x.data && x.data.allergens.length > 0) {
                return x.data.allergens;
              } else {
                return [];
              }
            })
            .flat()
        )
      ];
    }
  },
  data() {
    return {
      searchInput: ""
    };
  },
  methods: {
    onChange(v) {
      this.searchInput = "";
      this.$emit("input", v);
    }
  }
};
</script>

<style></style>
